import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle,
  quoteArticle,
  createArticle
} from "../../actions/catadvs";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  Button,
  Modal,
  UncontrolledAlert
} from "reactstrap";
import { Link } from "react-router-dom";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";

import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/profile/AdvArticleTable";
import AdvCheckForm from "../../components/userforums/AdvCheckForm";
import PaginationBar from "../../components/Commons/PaginationBar";
const CATEGORIES = [
  {
    id: 96,
    parent_id: 95,
    sort: 1,
    name: "job hunting",
    display_name: "工作求職"
  },
  {
    id: 97,
    parent_id: 95,
    sort: 2,
    name: "restaurant services",
    display_name: "餐館服務"
  },
  {
    id: 98,
    parent_id: 95,
    sort: 3,
    name: "housekeeping",
    display_name: "家政服務"
  },
  {
    id: 99,
    parent_id: 95,
    sort: 4,
    name: "repair and maintenance",
    display_name: "維修保養"
  },
  {
    id: 100,
    parent_id: 95,
    sort: 5,
    name: "business service",
    display_name: "商家服務"
  }
];
class FreelancerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      selectedUser: {},
      activeCategoryType: null,
      selects: {},
      paymentModal: false,
      article: {
        category_ids: [0],
        type: 0,
        vacancy_weeks: 0
      }
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggleSelectEvent = this.toggleSelectEvent.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.checkAvailability = this.checkAvailability.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter(value => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories() {
    this.props.getCategories();
  }

  hideAlert() {
    this.setState({
      alert: ""
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    let path = "user";
    let post_id = row.post.id;
    this.props.removeArticle({ post_id, path });
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterAuthor(author_id) {
    // const activeCategoryType = this.getCurrentCategory(author_id);
    // this.setState({
    //   activeCategoryType: activeCategoryType
    // });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  toggleSelectEvent(checked, index) {
    let selects = this.state.selects;
    selects[index] = checked;
    this.setState({
      selects
    });
  }

  toggleModal() {
    this.setState({
      paymentModal: !this.state.paymentModal
    });
  }

  checkAvailability() {
    let vacancy_weeks = this.state.article.vacancy_weeks;
    let type = this.state.article.type;
    let category_id = this.state.article.category_ids[0];
    this.props.quoteArticle({ vacancy_weeks, category_id, type });
  }

  onTextInputChange(e, target) {
    let value = e.target.value;
    if (value) {
      let article = this.state.article;
      article[target] = value;
      this.setState({
        article: article
      });
      let vacancy_weeks = this.state.article.vacancy_weeks;
      let type = this.state.article.type;
      let category_id = this.state.article.category_ids[0];
      this.props.quoteArticle({ vacancy_weeks, category_id, type });
    }
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(value);
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
    let vacancy_weeks = this.state.article.vacancy_weeks;
    let type = this.state.article.type;
    let category_id = this.state.article.category_ids[0];
    this.props.quoteArticle({ vacancy_weeks, category_id, type });
  }

  submitArticle() {
    const { category_ids, type, vacancy_weeks } = this.state.article;
    this.props.createArticle({
      category_id: category_ids[0],
      position: type,
      weeks: vacancy_weeks
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
      successBackMsg,
      errorMsg,
      getArticleRequest,
      errors,
      editArticleRequest,
      quoteMsg,
      errorQuoteMsg
    } = this.props.catadvs;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = [
      "狀態",
      "標題",
      "位置",
      "分類",
      "金額",
      "購買日期",
      "到期日期",
      "操作"
    ];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at"
    ];

    return (
      <>
        <Container className="mt-4" fluid>
          {this.state.alert}
          {errorMsg && (
            <UncontrolledAlert color="danger" fade={false}>
              <span className="alert-inner--text mb-4">{errorMsg}</span>
            </UncontrolledAlert>
          )}
          {successBackMsg && (
            <UncontrolledAlert color="success" fade={false}>
              <span className="alert-inner--text mb-4">{successBackMsg}</span>
            </UncontrolledAlert>
          )}
          <Card className="card-frame">
            <CardHeader className="border-0">
              <div className="d-flex align-items-center justify-content-between"></div>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h3>分類廣告</h3>
                </div>
                <div className="d-flex align-items-center">
                  <Button
                    color="default"
                    type="button"
                    onClick={() => this.toggleModal("exampleModal")}
                  >
                    發付費廣告
                  </Button>
                </div>
              </div>
            </CardHeader>
            <ArticleTable
              heads={heads}
              dataAttributes={dataAttributes}
              rows={articles}
              loading={getArticlesRequest}
              remove={this.removeArticle}
              toggleSingle={this.toggleSelectEvent}
              selects={this.state.selects}
            />
            <CardFooter className="py-4 d-flex justify-content-center">
              {articlesPagination.currentPage ? (
                <PaginationBar
                  currentPage={articlesPagination.currentPage}
                  totalPages={articlesPagination.lastPage}
                  pageNeighbours={1}
                  goToPage={page => this.goToPage(page)}
                />
              ) : null}
            </CardFooter>
          </Card>
        </Container>
        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.paymentModal}
          toggle={() => this.toggleModal("paymentModal")}
        >
          <div className="modal-header">
            <h5 className="modal-title" id="paymentModalLabel">
              選擇
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("paymentModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <AdvCheckForm
              data={this.state.article}
              onTextInputChange={this.onTextInputChange}
              handleCheckBoxChange={this.handleCheckBoxChange}
              submitArticle={this.submitArticle}
              loading={editArticleRequest}
            />
            {quoteMsg && (
              <UncontrolledAlert color="success" fade={false}>
                <span className="alert-inner--text mb-4">
                  {quoteMsg}
                  <br />
                  {this.props.catadvs.beginTime}
                </span>
              </UncontrolledAlert>
            )}
            {errorQuoteMsg}
          </div>
          <div className="modal-footer">
            <Button
              color="secondary"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("paymentModal")}
            >
              取消
            </Button>
            <Button
              disabled={!quoteMsg}
              className="btn btn-default"
              type="button"
              onClick={this.submitArticle}
            >
              填寫該種廣告
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    catadvs: state.catadvs,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    getCategories: params => dispatch(getCategories(params)),
    removeArticle: params => dispatch(removeArticle(params)),
    quoteArticle: params => dispatch(quoteArticle(params)),
    createArticle: params => dispatch(createArticle(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreelancerPage);
